import { defineComponent as _defineComponent } from 'vue'
import { useContext, useRoute, computed } from '@nuxtjs/composition-api';
import { Category } from '~/types/category';
import { FilterInfo } from '~/types/api';
import { removeLocale } from '~/utils/formatStrings';
import { shortCategoryTitle } from '~/utils/category';
import TLinkButton from '~/components/atoms/t-link-button.vue';

interface Props {
  showResourceTypes: boolean;
  showYearLevels: boolean;
  filteredResourceTypes?: FilterInfo[];
  filteredYearLevels?: FilterInfo[];
  category: Category;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilteredPageLinks',
  props: {
    showResourceTypes: { type: Boolean },
    showYearLevels: { type: Boolean },
    filteredResourceTypes: { default: () => [] },
    filteredYearLevels: { default: () => [] },
    category: null
  },
  setup(__props: any) {

const props = __props as { showResourceTypes: boolean, showYearLevels: boolean, filteredResourceTypes: FilterInfo[], filteredYearLevels: FilterInfo[], category: Category };

const { i18n } = useContext();
const route = useRoute();


const paths = route.value.fullPath.split('/');
const categoryParent = ['us', 'gb', 'au'].includes(paths[1]) ? paths[2] : paths[1];

const constructLink = (slug: string, category: string, categoryParent: string) => {
  const slugNoLocale = removeLocale(slug);
  return `/${categoryParent}/${category}/${slugNoLocale}`;
};

const pathIsNotCurrentRoute = (path: string) => {
  return path !== route.value.fullPath;
};

const resourceTypes = computed(() =>
  props.filteredResourceTypes
    .filter((value, index, self) => index === self.findIndex(o => o.slug === value.slug))
    .map(info => ({
      link: `/${i18n.locale}${constructLink(info.slug, props.category.slug, categoryParent)}/`,
      name: info.slug,
    }))
    .filter(filteredResourceType => pathIsNotCurrentRoute(filteredResourceType.link))
);
const yearlLevels = computed(() =>
  props.filteredYearLevels
    .filter((value, index, self) => index === self.findIndex(o => o.slug === value.slug))
    .map(info => ({
      link: `/${i18n.locale}${constructLink(info.slug, props.category.slug, categoryParent)}/`,
      name: info.slug,
    }))
    .filter(filteredYearLevel => pathIsNotCurrentRoute(filteredYearLevel.link))
);

return { __sfc: true,i18n, route, props, paths, categoryParent, constructLink, pathIsNotCurrentRoute, resourceTypes, yearlLevels, shortCategoryTitle, TLinkButton }
}

})